import { $t } from '../../composables/i18n'
import { Codebook } from '../Codebook'

export enum ReservationSourceId {
  EMAIL = 1,
  PHONE = 2,
  WEBSITE = 3,
  WALK_IN = 4,
  ONLINE = 5,
  AGENCY = 6,
  OTHER = 7,
  OWNER = 8,
  IMPORT = 9,
}

export class ReservationSource extends Codebook<ReservationSourceId> {
  static readonly EMAIL = new ReservationSource(ReservationSourceId.EMAIL, () => $t('E-mail'))
  static readonly PHONE = new ReservationSource(ReservationSourceId.PHONE, () => $t('Phone'))
  static readonly WEBSITE = new ReservationSource(ReservationSourceId.WEBSITE, () => $t('Website'))
  static readonly WALK_IN = new ReservationSource(ReservationSourceId.WALK_IN, () => $t('Walk-in'))
  static readonly ONLINE = new ReservationSource(ReservationSourceId.ONLINE, () => $t('Online'))
  static readonly AGENCY = new ReservationSource(ReservationSourceId.AGENCY, () => $t('Agency'))
  static readonly OTHER = new ReservationSource(ReservationSourceId.OTHER, () => $t('Other'))
  static readonly OWNER = new ReservationSource(ReservationSourceId.OWNER, () => $t('Owner'))
  static readonly IMPORT = new ReservationSource(ReservationSourceId.IMPORT, () => $t('Import'))

  private constructor(
    public readonly id: ReservationSourceId,
    public readonly name: () => string,
  ) {
    super(id)
  }
}
